export const sportsDict: Record<string, string> = {
  'nfl': 'Football',
  'mlb': 'Baseball',
  'all': 'All Sports'
};
let baseUrl = window.baseURL;
let defaultSport = window.defaultSport || 'nfl'

if (process.env.NODE_ENV === 'development') {
  // baseUrl = 'https://api.ftnfantasy.com';
  baseUrl = 'https://ftn-staging.dfsforecast.com';
//
// @ts-ignore
  // window.baseURL = 'https://ftn-staging.dfsforecast.com';
  // @ts-ignore
  defaultSport = 'nfl';
}

export const optIds = [2];

const tokenHardcoded = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxNTYxNjUsInR5cGUiOiJhY2Nlc3MiLCJtb2RlIjoiZGV2IiwiZXhwIjoxNzUxODk2NDY3fQ.10bqF9tB1UMUA87jFpp8JdMYFpqtxzhSal_rpKDMHk0'
// @ts-ignore
// window.baseURL = 'https://ftn-staging.dfsforecast.com';
const customNames: Record<string, string> = {
  'prod_RglHh396RgZheT': 'Contest Sims',
  // 'prod_PlfFOJkm1ZrTWI': "High Stakes +",
  // 'prod_PsUC4S5chF5FRz': 'High Stakes +',
  // 'prod_PZNcF6CTejkodM': 'High Stakes +',
  // 'prod_P5Lil1p2rCsgQc': 'High Stakes +',
  // 'prod_P8N3KdnMzCmSAC': 'High Stakes +',
  // 'prod_PuHKojyjGAoT2a': 'High Stakes +',
  'prod_P5LRWWje87I3Xi_prod_PXl7F7S4MYtwpK': 'Football',
  'prod_P36Nae9Wb0A4O3_prod_PXl7F7S4MYtwpK': 'Baseball',
  'prod_PZN1hfZpZz3pTH_prod_PZNRl9EJ64Ewgv': 'Football',
  'prod_PZNQBFShF9HUPE_prod_PZNRl9EJ64Ewgv': 'Baseball',
  'prod_P5Lil1p2rCsgQc_prod_PuHKojyjGAoT2a': 'Baseball',
  'prod_P8N3KdnMzCmSAC_prod_PuHKojyjGAoT2a': 'Football',
}
const seams = ['prod_RglHh396RgZheT'];

const highStakes = ['prod_PlfFOJkm1ZrTWI', 'prod_PsUC4S5chF5FRz', 'prod_PZNcF6CTejkodM', 'prod_P5Lil1p2rCsgQc', 'prod_P8N3KdnMzCmSAC', 'prod_PuHKojyjGAoT2a'];
const allProPlansIds = ['prod_PXl7F7S4MYtwpK', 'prod_PZNRl9EJ64Ewgv'];
const allProPlansChildren = ['prod_P5LRWWje87I3Xi', 'prod_P36Nae9Wb0A4O3', 'prod_PZN1hfZpZz3pTH', 'prod_PZNQBFShF9HUPE']

const highStakesAdditional = ['prod_PuHKojyjGAoT2a'];
const yearlyOnly = ['prod_SboHLEl9fqtQ5R', 'prod_Sbo87eIOQ0XXcT', 'prod_QRFngAS66AKIBx', 'prod_QRHh092ehX8KUb', 'prod_P36Nae9Wb0A4O3', ...highStakesAdditional, ...highStakes];

export {
  baseUrl,
  defaultSport,
  tokenHardcoded,
  yearlyOnly,
  highStakes,
  allProPlansIds,
  allProPlansChildren,
  highStakesAdditional,
  seams,
  customNames
};

